var _mapMarkerInheritanceSetUp = false

window.MapMarker = function MapMarker(params) {
  if (!_mapMarkerInheritanceSetUp) {
    Object.setPrototypeOf(
      MapMarker.prototype,
      google.maps.OverlayView.prototype,
    )
    _mapMarkerInheritanceSetUp = true
  }
  this.containerDiv_ = null
  this.contentDiv_ = null
  this.content_ = params.content
  this.containerClasses_ = params.containerClasses
  this.ariaLabel_ = params.ariaLabel
  this.position_ = new google.maps.LatLng(params.position)
  this.onClick_ = params.onClick
  this.onMouseEnter_ = params.onMouseEnter
  this.onMouseLeave_ = params.onMouseLeave
  this.id = params.id
  this.propertyRecommendedPosition = params.propertyRecommendedPosition
  this.map_ = params.map
  this.setMap(this.map_)
}

Object.defineProperty(MapMarker.prototype, "position", {
  get: function () {
    return this.position_
  },
})

MapMarker.prototype.isVisible = function () {
  return this.map_.getBounds().contains(this.position_)
}

MapMarker.prototype.setContent = function (content) {
  this.content_ = content
  this.draw()
}

MapMarker.prototype.addContainerClass = function (cls) {
  this.containerClasses_ = (this.containerClasses_ || []).concat(cls)
  if (this.containerDiv_) this.containerDiv_.classList.add(cls)
}

MapMarker.prototype.getPosition = function () {
  return this.position_
}

MapMarker.prototype.select = function () {
  google.maps.event.trigger(this.map_, "marker_selected", this)
}

MapMarker.prototype.deselect = function () {
  google.maps.event.trigger(this.map_, "marker_selected", null)
}

MapMarker.prototype.onMarkerSelect_ = function (selectedMarker) {
  if (this === selectedMarker) {
    this.containerDiv_.classList.add("google-maps-marker--container_selected")
  } else {
    this.containerDiv_.classList.remove(
      "google-maps-marker--container_selected",
    )
  }
}

MapMarker.prototype.remove = function () {
  this.setMap(null)
}

// The onRemove() method will be called automatically from the API if
// we ever set the overlay's map property to 'null'.
MapMarker.prototype.onRemove = function () {
  google.maps.event.removeListener(this.markerSelectEventHandler_)
  this.containerDiv_.parentNode.removeChild(this.containerDiv_)
  this.containerDiv_ = null
}

// onAdd is called when the map's panes are ready and the overlay has been
// added to the map.
MapMarker.prototype.onAdd = function () {
  var containerDiv = document.createElement("div")
  var contentDiv = document.createElement("div")

  containerDiv.classList.add("google-maps-marker--container")
  if (this.ariaLabel_) {
    containerDiv.setAttribute("aria-label", this.ariaLabel_)
  }
  contentDiv.classList.add("google-maps-marker")
  if (this.containerClasses_) {
    containerDiv.classList.add.apply(
      containerDiv.classList,
      this.containerClasses_,
    )
  }
  containerDiv.appendChild(contentDiv)

  contentDiv.innerHTML = this.content_

  if (typeof this.onClick_ === "function") {
    containerDiv.addEventListener("click", this.onClick_.bind(this, this))
  }

  if (typeof this.onMouseEnter_ === "function") {
    containerDiv.addEventListener(
      "mouseenter",
      this.onMouseEnter_.bind(this, this),
    )
  }

  if (typeof this.onMouseLeave_ === "function") {
    containerDiv.addEventListener(
      "mouseleave",
      this.onMouseLeave_.bind(this, this),
    )
  }

  this.markerSelectEventHandler_ = this.map_.addListener(
    "marker_selected",
    this.onMarkerSelect_.bind(this),
  )

  this.containerDiv_ = containerDiv
  this.contentDiv_ = contentDiv

  var panes = this.getPanes()
  panes.overlayMouseTarget.appendChild(containerDiv)
}

MapMarker.prototype.draw = function () {
  if (!this.containerDiv_) return

  var overlayProjection = this.getProjection()
  var center = overlayProjection.fromLatLngToDivPixel(this.position_)

  var positionStyles = "left:" + center.x + "px;" + "top:" + center.y + "px;"

  this.containerDiv_.setAttribute("style", positionStyles)
  if (this.content_ !== this.contentDiv_.innerHTML) {
    this.contentDiv_.innerHTML = this.content_
  }
}
